import {createBrowserTurnLatencyTracker} from '@github-ui/copilot-browser-latency/turn-latency'
import {flushBatchedEvents, sendEvent} from '@github-ui/hydro-analytics'

export function createCopilotChatTurnLatencyTracker() {
  return createBrowserTurnLatencyTracker({
    now: () => performance.timeOrigin + performance.now(),
    timeOrigin: () => performance.timeOrigin,
    emit: (eventName, payload) => sendEvent(eventName, payload),
    flush: () => flushBatchedEvents(),
  })
}
